// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-card-shell {
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  padding-bottom: 56px;
}

.report-card-img-container {
  padding-top: 18px;
}

.report-card-img {
  width: 160px;
  height: 240px;
  object-fit: cover;
}

.report-card-type-grid {
  padding: 0;
}

.report-card-type-row-inner {
  align-items: center;
}

.report-type-icon {
  font-size: 0.85rem;
}

.report-card-title {
  text-align: center;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 1.25rem;
  margin-top: 8px;
}

.report-card-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 9px 2px 0px 2px;
  gap: 6px;
}

.report-card-title-text {
  font-size: 0.8rem;
  color: var(--ion-color-primary-contrast);
  margin-bottom: 2px;
}

.report-card-collection {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  padding: 8px;
}
.report-card-collection ion-icon {
  font-size: 0.82rem;
}

.report-card-groupname {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.73rem;
}

.report-card-group {
  font-size: 0.73rem;
}

.report-card-desc-link {
  position: absolute;
  bottom: 62px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  color: var(--ion-color-medium);
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.97rem;
}

.report-card-desc {
  font-size: 0.97rem;
  color: var(--ion-color-medium);
}

.report-card-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  box-shadow: none;
  background: var(--ion-card-background, var(--ion-color-tertiary));
  display: flex;
  justify-content: center;
  padding: 4px 0;
}

.report-card-fav-btn {
  width: 90%;
  max-width: 220px;
  font-weight: 500;
}

@media only screen and (min-width: 720px) {
  ion-card {
    width: 250px;
    height: 345px;
  }
  ion-card hr {
    border-bottom: 1px solid var(--ion-color-secondary-contrast);
  }
  ion-card .icon {
    display: block;
    margin-left: auto;
    margin-right: auto;
    zoom: 1.3;
  }
  ion-card .favorite-icon {
    border-radius: 35%;
    padding: 1px;
    zoom: 1.6;
  }
  ion-card .favorite-icon:hover {
    transform: scale(1.2);
    background-color: rgba(255, 255, 255, 0.062745098);
  }
  ion-card .group-logo {
    height: 150px;
    width: 190px;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
  }
  ion-card .card-title {
    font-size: 17px;
    margin-top: -7px;
    padding-top: 0px;
    padding-right: 9px;
    padding-bottom: 5px;
    padding-left: 9px;
  }
  ion-card .card-content {
    bottom: 10px;
    font-size: 14px;
    font-weight: initial;
  }
  ion-card .item.native .item-inner {
    padding-right: 0px !important;
    --inner-padding-end: 0px !important;
  }
}
.hoverOnCard:hover {
  cursor: pointer;
}

.description-popover {
  --width: 320px !important;
  --max-width: 90vw !important;
  --border-radius: 12px !important;
}
.description-popover .description-popover-content {
  --background: var(--ion-color-secondary) !important;
  color: var(--ion-color-secondary-contrast) !important;
}
.description-popover .description-popover-content .description-header {
  display: flex;
  align-items: center;
  padding: 16px 20px 12px 20px;
  background: var(--ion-color-medium);
}
.description-popover .description-popover-content .description-header .description-icon {
  font-size: 20px;
  margin-right: 10px;
}
.description-popover .description-popover-content .description-header .description-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ion-color-primary-contrast);
}
.description-popover .description-popover-content .description-body {
  padding: 16px 20px;
}
.description-popover .description-popover-content .description-body .description-text {
  line-height: 1.5;
}

.custom-popover-css {
  --width: fit-content !important;
}

@media only screen and (max-width: 720px) {
  ion-card {
    zoom: 0.9;
    width: 196px;
    height: 285px;
  }
  ion-card hr {
    border-bottom: 1px solid var(--ion-color-secondary-contrast);
  }
  ion-card .icon {
    display: block;
    margin-left: auto;
    margin-right: auto;
    color: var(--ion-color-secondary-contrast);
  }
  ion-card .group-logo {
    height: 85px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  ion-card .card-title {
    color: var(--ion-color-primary-contrast);
    font-size: 14px;
  }
  ion-card .card-content {
    font-size: 12px;
    font-weight: initial;
  }
  ion-card .card-detailsbutton {
    background-color: rgba(255, 255, 255, 0.0509803922);
    padding-left: 10px;
    padding-top: 3px;
    padding-right: 10px;
    padding-bottom: 3px;
    border-radius: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/report-card/report-card.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,QAAA;AACF;;AACA;EACE,iBAAA;EACA,wCAAA;EACA,kBAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EAEA,mBAAA;EACA,YAAA;AAEF;AADE;EAAW,kBAAA;AAIb;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAKF;;AAHA;EACE,kBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;AAOF;;AALA;EACE,kBAAA;EACA,8BAAA;AAQF;;AANA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,iEAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AASF;;AAPA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AAUF;;AARA;EACE;IACE,YAAA;IACA,aAAA;EAWF;EAVE;IACE,4DAAA;EAYJ;EAVE;IACE,cAAA;IACA,iBAAA;IACA,kBAAA;IACA,SAAA;EAYJ;EAVE;IACE,kBAAA;IACA,YAAA;IAKA,SAAA;EAQJ;EAZI;IACE,qBAAA;IACA,kDAAA;EAcN;EAVE;IACE,aAAA;IACA,YAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EAYJ;EAVE;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;EAYJ;EAVE;IACE,YAAA;IACA,eAAA;IACA,oBAAA;EAYJ;EACE;IACE,6BAAA;IACA,mCAAA;EACJ;AACF;AAKE;EACE,eAAA;AAHJ;;AAMA;EACE,yBAAA;EACA,4BAAA;EACA,gCAAA;AAHF;AAKE;EACE,mDAAA;EACA,qDAAA;AAHJ;AAKI;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,mCAAA;AAHN;AAKM;EACE,eAAA;EACA,kBAAA;AAHR;AAMM;EACE,eAAA;EACA,gBAAA;EACA,wCAAA;AAJR;AAQI;EACE,kBAAA;AANN;AAQM;EACE,gBAAA;AANR;;AAaA;EACE,+BAAA;AAVF;;AAcA;EACE;IACE,SAAA;IACA,YAAA;IACA,aAAA;EAXF;EAYE;IACE,4DAAA;EAVJ;EAYE;IACE,cAAA;IACA,iBAAA;IACA,kBAAA;IACA,0CAAA;EAVJ;EAYE;IACE,YAAA;IAEA,cAAA;IACA,iBAAA;IACA,kBAAA;EAXJ;EAaE;IACE,wCAAA;IACA,eAAA;EAXJ;EAaE;IACE,eAAA;IACA,oBAAA;EAXJ;EAaE;IACE,mDAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EAXJ;AACF","sourcesContent":["// Card shell and layout\n.report-card-shell {\n  border-radius: 18px;\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 56px;\n}\n\n.report-card-img-container {\n  padding-top: 18px;\n}\n\n.report-card-img {\n  width: 160px;\n  height: 240px;\n  object-fit: cover;\n}\n\n.report-card-type-grid {\n  padding: 0;\n}\n.report-card-type-row-inner {\n  align-items: center;\n}\n\n.report-type-icon {\n  font-size: 0.85rem;\n}\n\n.report-card-title {\n  text-align: center;\n  margin-bottom: 5px;\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-top: 8px;\n}\n// Info block: stacks title → collapsableTitle → groupName\n.report-card-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 9px 2px 0px 2px;\n  gap: 6px;\n}\n.report-card-title-text {\n  font-size: 0.8rem;\n  color: var(--ion-color-primary-contrast);\n  margin-bottom: 2px;\n}\n.report-card-collection {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n  // background: rgba(var(--ion-color-primary-rgb), 0.1);\n  border-radius: 12px;\n  padding: 8px;\n  ion-icon { font-size: 0.82rem; }\n}\n.report-card-groupname {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.73rem;\n}\n.report-card-group {\n  font-size: 0.73rem;\n}\n.report-card-desc-link {\n  position: absolute;\n  bottom: 62px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  color: var(--ion-color-medium);\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 0.97rem;\n}\n.report-card-desc {\n  font-size: 0.97rem;\n  color: var(--ion-color-medium);\n}\n.report-card-footer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  box-shadow: none;\n  background: var(--ion-card-background, var(--ion-color-tertiary));\n  display: flex;\n  justify-content: center;\n  padding: 4px 0;\n}\n.report-card-fav-btn {\n  width: 90%;\n  max-width: 220px;\n  font-weight: 500;\n}\n@media only screen and (min-width: 720px) {\n  ion-card {\n    width: 250px;\n    height: 345px;\n    hr {\n      border-bottom: 1px solid var(--ion-color-secondary-contrast);\n    }\n    .icon {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n      zoom: 1.3;\n    }\n    .favorite-icon {\n      border-radius: 35%;\n      padding: 1px;\n      &:hover {\n        transform: scale(1.2);\n        background-color: #ffffff10;\n      }\n      zoom: 1.6;\n    }\n    .group-logo {\n      height: 150px;\n      width: 190px;\n      object-fit:contain;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .card-title {\n      font-size: 17px;\n      margin-top: -7px;\n      padding-top: 0px;\n      padding-right: 9px;\n      padding-bottom: 5px;\n      padding-left: 9px;\n    }\n    .card-content {\n      bottom: 10px;\n      font-size: 14px;\n      font-weight: initial;\n    }\n    // .card-detailsbutton {\n    //   &:hover {\n    //     transform: scale(1.13);\n    //     background-color: #ffffff10;\n    //     padding-left: 10px;\n    //     padding-top: 3px;\n    //     padding-right: 10px;\n    //     padding-bottom: 3px;\n    //     border-radius: 6px;\n    //   }\n    // }\n    .item.native .item-inner {\n      padding-right: 0px !important;\n      --inner-padding-end: 0px !important;\n    }\n  }\n}\n\n\n.hoverOnCard {\n  &:hover {\n    cursor: pointer;\n  }\n}\n.description-popover {\n  --width: 320px !important;\n  --max-width: 90vw !important;\n  --border-radius: 12px !important;\n\n  .description-popover-content {\n    --background: var(--ion-color-secondary) !important;\n    color: var(--ion-color-secondary-contrast) !important;\n\n    .description-header {\n      display: flex;\n      align-items: center;\n      padding: 16px 20px 12px 20px;\n      background: var(--ion-color-medium);\n\n      .description-icon {\n        font-size: 20px;\n        margin-right: 10px;\n      }\n\n      .description-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: var(--ion-color-primary-contrast);\n      }\n    }\n\n    .description-body {\n      padding: 16px 20px;\n\n      .description-text {\n        line-height: 1.5;\n      }\n    }\n  }\n}\n\n// Legacy class for backward compatibility\n.custom-popover-css {\n  --width: fit-content !important;\n}\n\n\n@media only screen and (max-width: 720px) {\n  ion-card {\n    zoom: 0.9;\n    width: 196px;\n    height: 285px;\n    hr {\n      border-bottom: 1px solid var(--ion-color-secondary-contrast);\n    }\n    .icon {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n      color: var(--ion-color-secondary-contrast);\n    }\n    .group-logo {\n      height: 85px;\n      // width: 120px;\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .card-title {\n      color: var(--ion-color-primary-contrast);\n      font-size: 14px\n    }\n    .card-content {\n      font-size: 12px;\n      font-weight: initial\n    }\n    .card-detailsbutton {\n      background-color: #ffffff0d;\n      padding-left: 10px;\n      padding-top: 3px;\n      padding-right: 10px;\n      padding-bottom: 3px;\n      border-radius: 6px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
